module.exports = __webpack_public_path__ + "img/81.5.COD.206bea50.png";